import React, { useState } from 'react';
import { Eye, Trash2, MessageSquare } from 'lucide-react';
import DeleteThreadModal from '../DeleteProjectModal/deleteThreadModal';
import { CardMenu } from '../ui';
import { useNavigate } from 'react-router-dom';

const ThreadCard = ({ threadCardsData, refetch }) => {
  const navigate = useNavigate();
  const [deleteCard, setDeleteCard] = useState(null);

  return (
    <>
      {threadCardsData.map(card => (
        <div
          key={card?.session_id}
          className="p-5 rounded-[22px] bg-elevated shadow-soft border border-shell-border hover:border-ink/20 hover:bg-paper transition-all duration-200">
          <div className="flex items-start gap-4">
            <button
              type="button"
              onClick={() => navigate(`/chat/${card?.session_id}`)}
              className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 bg-primary/10">
              <MessageSquare className="w-5 h-5 text-primary" />
            </button>
            <button
              type="button"
              onClick={() => navigate(`/chat/${card?.session_id}`)}
              className="flex-1 min-w-0 text-left">
              <h3
                className="text-base font-semibold text-ink mb-1 truncate capitalize"
                dangerouslySetInnerHTML={{ __html: card?.title }}
              />
              <p
                className="text-sm text-mute leading-relaxed line-clamp-2"
                dangerouslySetInnerHTML={{ __html: card?.initial_message }}
              />
            </button>
            <CardMenu
              items={[
                { label: 'View Chat', icon: Eye, onClick: () => navigate(`/chat/${card?.session_id}`) },
                { label: 'Delete Thread', icon: Trash2, onClick: () => setDeleteCard(card), danger: true },
              ]}
            />
          </div>
          <p className="text-xs text-mute mt-3 pl-14">
            Updated: <span dangerouslySetInnerHTML={{ __html: card?.updated_at }} />
          </p>
        </div>
      ))}

      {deleteCard && (
        <DeleteThreadModal onClose={() => setDeleteCard(null)} _id={deleteCard?.session_id} refetch={refetch} />
      )}
    </>
  );
};

export default ThreadCard;
